<div class="loader">
  <img style="margin-right: 2rem;" src="./assets/loading.gif" alt="Loading" />

  <p>Carregando...</p>
</div>
